import axios, { AxiosInstance } from "axios"
import { APP_ENV } from "app/environment"
import { BasicAuthToken } from "stores/utils/BasicAuthStore"

// if we call the application via our internal domain, we don´t use the Kong proxy
export const useKongProxy =
  APP_ENV.MODE !== "development" &&
  !window.location.href.includes("td-wowi-shop-frontend")

const internalBaseURL = "/api/"

const developmentBaseURL = `${APP_ENV.VITE_DEV_BACKEND_BASE_URL}${internalBaseURL}`

const productionBaseURL = `${useKongProxy ? APP_ENV.VITE_WOWI_SHOP_PATH_PREFIX : ""}${internalBaseURL}`

const baseURL =
  APP_ENV.MODE === "development" ? developmentBaseURL : productionBaseURL

export enum AppContext {
  CUSTOMER_CENTER = "customer-center",
  WOWI_SHOP = "shop",
}

const BaseUrlSuffix: Record<AppContext, string> = {
  [AppContext.CUSTOMER_CENTER]: "customer_center",
  [AppContext.WOWI_SHOP]: "shop",
};

export default class APIClient {
  axios: AxiosInstance

  constructor(context: AppContext) {
    this.axios = axios.create({
      baseURL: `${baseURL}${BaseUrlSuffix[context]}`,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      responseType: "json",
    })
  }

  setToken(token: BasicAuthToken) {
    if (token) {
      this.axios.defaults.headers.common.AuthToken = token;
    } else {
      delete this.axios.defaults.headers.common.AuthToken;
    }
  }

  async post<ResponseType = any, PayloadType = any>(
    url: string,
    payload?: PayloadType
  ): Promise<ResponseType> {
    const res = await this.axios.post<ResponseType>(url, payload)
    return res.data
  }

  async put<ResponseType = any, PayloadType = any>(
    url: string,
    payload?: PayloadType
  ): Promise<ResponseType> {
    const res = await this.axios.put<ResponseType>(url, payload)
    return res.data
  }

  async patch<ResponseType = any, PayloadType = any>(
    url: string,
    payload?: PayloadType
  ): Promise<ResponseType> {
    const res = await this.axios.patch<ResponseType>(url, payload)
    return res.data
  }

  async get<ResponseType = any, ParamsType = any>(
    url: string,
    params?: ParamsType
  ): Promise<ResponseType> {
    const res = await this.axios.get<ResponseType>(url, { params })
    return res.data
  }

  async delete<ResponseType = any, PayloadType = any>(
    url: string,
    data?: PayloadType
  ): Promise<ResponseType> {
    const res = await this.axios.delete<ResponseType>(url, { data })
    return res.data
  }
}
